import styled, { css } from 'styled-components';

const minHeightWrapper = '498px';
const widthTitle = '300px';
const widthContent = '355px';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    padding: ${theme.spacing.km0} ${theme.spacing.km10} ${theme.spacing.km0}
      ${theme.spacing.km10};
    min-height: ${minHeightWrapper};
    margin-top: ${theme.spacing.km6};
    flex-direction: column;
    justify-content: center;
  `}
`;

export const WrapperTitle = styled.div`
  width: ${widthTitle};
  max-width: 100%;
`;

export const WrapperContent = styled.div`
  width: ${widthContent};
  max-width: 100%;
`;
